/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Email_SetupInputs */



/**
* | output |
* | --- |
* | "Set up" |
*
* @param {Profile_Email_SetupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_email_setup = /** @type {((inputs?: Profile_Email_SetupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Email_SetupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configurar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Configurar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configura")
	return /** @type {LocalizedString} */ ("Set up")
});